import React from 'react';
import { Route, Switch, Redirect  } from "react-router-dom";
import Login from './components/Login/Login';
import Home from './views/Home/Home';
import Result from './components/Search/Search';
import Services from './views/Services/Services';
import Maintenance from './views/Maintenance/Maintenance';
import Contact from './components/Contact/Contact';
function Routes() {  
//   const RedirectToLogin = ({ component: Component, ...rest }) => {
//     return (

//         // -- Redirect to Login if not logged in -- //

//         // <Route
//         //     {...rest}
//         //     render={(props) =>
//         //         sessionStorage.getItem('userInfo') ? (
//         //                 <Component {...props} />                    
//         //         ) : (
//         //                 <Redirect to="/login" />
//         //             )}
//         // />

//         // -- Redirect to Login if not logged in -- //

//     );
// };
  return (
   
    <main>
        <Switch>
            {/* Login route */}
            {/* <Route path="/login" component={Login} exact /> */}
            
            {/* Home route */}            
            {/* <Route path={"/"} component={Maintenance} exact /> */}
            <Route path={"/"} component={Result} exact/>
            <Route path={"/about-us"} component={Home}/>
            <Route path={"/services"} component={Services}/>
            <Route path="/contact-us" component={Contact}/>
            <Route path="/abonnementgroupemach" component={()=>{
              window.location.href = "https://processsystech.azurewebsites.net/Account/Login?id=4";
            }}/>
            <Route path="/11003" component={()=>{
              window.location.href = "https://blinkay.app/appz?z=43803";
            }}/>
            {/* Redirect route */}            
            <Redirect from="/" to="/" />
            
        </Switch>
    </main>
  );
}

export default Routes;
